import { Component } from '@angular/core';

@Component({
  selector: 'app-header-contacts',
  templateUrl: './header-contacts.component.html',
  styleUrls: ['./header-contacts.component.css']
})
export class HeaderContactsComponent {

}
